module.exports = __webpack_public_path__ + "static/media/promo3-background-desk.a713b042.svg";